import * as React from "react";
import styled from "styled-components";
import ProgressBar from "./ProgressBar";
import VapeView from "./VapeView";
import DrugsView from "./DrugsView";
import BACView from "./BACView";
import RightArrow from '../resources/right-arrow.svg';
import CandidateInfo from "./CandidateInfo";
import { useNavigate } from 'react-router-dom';
import SchoolInfo from "./SchoolInfo";
import Alcohol from "./Alcohol";
import Loader from '../components/Loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BackButton from '../components/BackButton'; // adjust path if needed
import { calculateMetrics1 } from '../utils/calculateMetrics1';
import { saveSubmission } from '../api/saveSubmission';


const MIView1 = () => {

    // use state to keep track of logged in status of user 
    // if user is not logged in, redirect to login page
    // if user is logged in, render the page

    const [nextButton, setNextButton] = React.useState(false);
    const [index, setIndex] = React.useState(0);
    const [selected, setSelected] = React.useState("candidateInfo");  
    const [loading, setLoading] = React.useState(true); 
    const [showUnanswered, setShowUnanswered] = React.useState(false);
    const history = useNavigate();
    const scrollRef = React.useRef(null);
    const [studentResponses, setStudentResponses] = React.useState(sessionStorage.getItem("studentResponses") ? JSON.parse(sessionStorage.getItem("studentResponses")) : {});
    
    const setStudentResponseData = (data) => {
        const newStudentResponses = {...studentResponses, ...data};
        setStudentResponses(newStudentResponses);  
    }
    React.useEffect(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, [index]);

    const components = [
        {
            title:"candidateInfo",
            view: <CandidateInfo setCandidateData={setStudentResponseData} setNextButton={setNextButton} showUnanswered={showUnanswered} onAllAnswered={setShowUnanswered} />,
        },
        {
            title:"schoolInfo",
            view: <SchoolInfo age={studentResponses['age']} setSchoolInfoData={setStudentResponseData} setNextButton={setNextButton} showUnanswered={showUnanswered} onAllAnswered={setShowUnanswered} />,
        },
        {
            title:"vape",
            view: <VapeView age={studentResponses['age']} setVapeData={setStudentResponseData} setNextButton={setNextButton} showUnanswered={showUnanswered} onAllAnswered={setShowUnanswered}/>,
        },
        {
            title:"drugs",
            view: <DrugsView age={studentResponses['age']} setDrugData={setStudentResponseData} setNextButton={setNextButton} showUnanswered={showUnanswered} onAllAnswered={setShowUnanswered}/>,
        },
        {
            title:"alcohol",
            view: <Alcohol age={studentResponses['age']} setAlcoholAnswersData={setStudentResponseData} setNextButton={setNextButton} showUnanswered={showUnanswered} onAllAnswered={setShowUnanswered}/>,
        },
        {
            title:"bac",
            view: <BACView age={studentResponses['age']} setBACAnswersData={setStudentResponseData} setNextButton={setNextButton} showUnanswered={showUnanswered} onAllAnswered={setShowUnanswered}/>,
        }
    ];
    
const onBack = () => {
  if (index > 0) {
    const newIndex = index - 1;
    setIndex(newIndex);
    setSelected(components[newIndex].title);
    sessionStorage.setItem("selectedPageIndex", String(newIndex));
    setShowUnanswered(false);   // optional
    setNextButton(true);        // optional: lets user hit Next right away
  } else {
    // history(-1); // leave commented if you never want to exit from first page
  }
};




    const onSectionChange = async () => {
        if (!nextButton) {
            toast.error('Please answer all marked questions before moving to the next section!!!');
            setShowUnanswered(true);
            return;
        }
    
        if (components[index].title === "bac") {
  console.log("[MIView1] step:", components[index].title);

  const PARTID = sessionStorage.getItem("PARTID") || "LOCAL_PARTID_" + Date.now();
  const age = sessionStorage.getItem("age") || studentResponses['age'];
  const gender = sessionStorage.getItem("gender_assigned_at_birth") || studentResponses['gender_assigned_at_birth'];

  // Log the raw data before calculation
  console.log("[MIView1] studentResponses (pre-calc):", JSON.stringify({
    ...studentResponses,
    age,
    gender_assigned_at_birth: gender
  }, null, 2));

  try {
    const metrics = calculateMetrics1({
      ...studentResponses,
      age,
      gender_assigned_at_birth: gender,
    });

    // Log the calculated metrics
    console.log("[MIView1] metrics (post-calc):", JSON.stringify(metrics, null, 2));
    const participantId = PARTID; // capture before clearing storage
    const demographics = {
      // include only what you want to persist as demographics for MI1
      month: studentResponses.month,
      year: studentResponses.year,
      age,
      gender_assigned_at_birth: gender,
      HOMETYPE_N: studentResponses.HOMETYPE_N,
      HINCOMEO_N: studentResponses.HINCOMEO_N,
      COLLEGE: studentResponses.COLLEGE,
      // ... add/remove as needed
    };

    await saveSubmission({
      participantId,
      formType: 'MI1',
      demographics,
      raw: studentResponses,   // full pre-calc payload you logged
      metrics,                 // post-calc metrics
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
    });
    // --------- END SAVE CALL INSERTION ---------
    // Clear sessionStorage and save new data
    sessionStorage.clear();
    sessionStorage.setItem("PARTID", PARTID);
    sessionStorage.setItem("mi_metrics1_submitted", 1);
    sessionStorage.setItem("logged_in", true);
    sessionStorage.removeItem("MI1Metrics"); // ensure old is gone
    sessionStorage.setItem("MI1Metrics", JSON.stringify(metrics));
    sessionStorage.setItem("age", age);
    sessionStorage.setItem("gender_assigned_at_birth", gender);

    // Log the data we just saved
    console.log("[MIView1] just saved MI1Metrics:", sessionStorage.getItem("MI1Metrics"));

    history('/MI/Metrics');
  } catch (err) {
    console.error("Error calculating metrics", err);
    toast.error("Could not process report data.");
  }
}
 else {
  if (index === 0) {
    sessionStorage.setItem("age", studentResponses['age']);
    sessionStorage.setItem("gender_assigned_at_birth", studentResponses["gender_assigned_at_birth"]);
  }

  setSelected(components[index + 1].title);
  setIndex(index + 1);
  sessionStorage.setItem("selectedPageIndex", index + 1);
  sessionStorage.setItem("studentResponses", JSON.stringify(studentResponses));
}

    };
    
      
        

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            // setShowComponent(true);
            // console.log("timeout");
            if(!sessionStorage.getItem('logged_in') || parseInt(sessionStorage.getItem('mi_metrics1_submitted')) == 1 || parseInt(sessionStorage.getItem('mi_metrics2_submitted')) == 1){
                history('/');
            }
            setLoading(false);
            if (sessionStorage.getItem("selectedPageIndex") != 0) {
                setSelected(components[parseInt(sessionStorage.getItem("selectedPageIndex"))].title);
                setIndex(parseInt(sessionStorage.getItem("selectedPageIndex")));
            } else {
                sessionStorage.setItem("selectedPageIndex",0);
            }
            
        }, 1000);

        // Clean-up function to clear the timeout when the component unmounts
        return () => clearTimeout(timeout);
        
    }, []);

    return(
        loading ? <div>
            <Loader />
        </div> :
        <VapeWrap ref={scrollRef}>
            <ToastContainer 
            position="top-center"
            closeOnClick
            
            style={{
                width: 'auto',
            }} />
            <Content>     
            <ProgressBarWrap>
               <ProgressBar selected={selected} />
            </ProgressBarWrap>
            <Form>
  

    {components.filter((i) => i.title === selected)[0]?.view}
   <ButtonWrap>
  <BackButton enabled={index > 0} onClick={onBack} />
  <Button
    enabled={nextButton}
    style={{ backgroundColor: nextButton ? "#025dc7" : "grey" }}
    onClick={onSectionChange}
  >
    Next <img src={RightArrow} height={30} />
  </Button>
</ButtonWrap>


            </Form>
            </Content> 
        </VapeWrap>
    );
}

const VapeWrap = styled.article`
width: 100%;
overflow-y: scroll;
height: -webkit-fill-available;
background-color: #D3EEFF;
display: flex;
    flex-direction: column;
    /* align-items: center; */
    padding: 0 0 40px;
    .rc-slider{
        /* width: 70%; */
    }
    .rc-slider-handle{
        &:focus{ 
              /* border: none !important; */
           outline: black;
           /* box-shadow: none; */
        }
            /* background-color: black; */
    }
    h2{
        /* font-size: 1em; */
        font-size: 22px;
        /* margin: 0; */
        /* margin-left: 35px; */
    }
    h3{
        /* font-size: 0.8em; */
        font-size: 18px;
        margin: 0;
        /* padding: 5px 0; */
        /* line-height: 0; */
    }
    p{
        /* font-size: 0.6em; */
        font-size: 15px;
        margin: 0;
        /* padding: 5px 0; */
        /* line-height: 25px; */
    }

    @media (max-width: 768px) {
        h2{
            font-size: 18px;
        }
        h3{
            font-size: 16px;
        }
        p{
            font-size: 14px;
        }
    }
    @media (max-width: 576px) {

        h2{
            font-size: 16px;
        }
        h3{
            font-size: 14px;
        }
        p{
            font-size: 12px;
        }
        
    }
`;
const ProgressBarWrap = styled.section`
    display: flex;
    justify-content: center;
    margin: 20px 0 20px 0;
    width: 100%;
`;
export const Content = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const Form = styled.section`
width: 70%;
position: relative;
background-color: white;
margin: 20px 100px;
padding: 30px;
@media only screen and (max-width: 768px) {
      width: 85%;
      margin: 0px;
      padding: 10px 15px 20px;
    }
`;
export const Button = styled.button`
background-color: #025dc7;
cursor: pointer;
border: none;
border-radius: 25px;
color: white;
display: flex;
    align-items: center;
    img{
        margin-left: 10px;
    }
    padding: 0px 20px;
    @media only screen and (max-width: 700px) {
font-size: 10px;
    height: 22px !important;
    padding: 0px 10px;
    img{
        height: 17px;
        margin-left: 5px;
    }
}
`;
export const ButtonWrap = styled.div`
  position: absolute;
  bottom: -50px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
`;


export default MIView1;